module.exports = __webpack_public_path__ + "static/media/GreatTailoringService.0b03065d.png";